import { useState } from "react";
import Select from "react-select";

function OfferPresencial() {
  const [prueba, setPrueba] = useState(null);
  const [facultad, setFacultad] = useState(null);

  const optionsPrueba = [
    {
      value: "todos",
      label: "Toda la oferta",
    },
    {
      value: "Selección",
      label: "Selección",
    },
    {
      value: "Diagnóstica",
      label: "Diagnóstica",
    },
  ];

  const optionsFacultad = [
    {
      value: "todos",
      label: "Toda la oferta",
    },
    {
      value: "Ciencias de la Salud",
      label: "Ciencias de la Salud",
    },
    {
      value: "Ciencias Económicas y Empresariales",
      label: "Ciencias Económicas y Empresariales",
    },
    {
      value: "Ciencias Exactas y Naturales",
      label: "Ciencias Exactas y Naturales",
    },
    {
      value: "Ciencias Sociales, Educación y Humanidades",
      label: "Ciencias Sociales, Educación y Humanidades",
    },
    {
      value: "Ciencias Jurídicas y Políticas",
      label: "Ciencias Jurídicas y Políticas",
    },
    {
      value: "Ingenierías y Arquitectura",
      label: "Ingenierías y Arquitectura",
    },
  ];

  function IsTag(data) {
    if (data && data.trim && data.trim() !== "") {
      return <p className="tag-2">{data}</p>;
    }
    return null; // Renderiza nada si data está vacío
  }

  function IsOrganiza(data) {
    if (data && data.trim && data.trim() !== "") {
      return (
        <p>
          <b>Organiza:</b> {data}
        </p>
      );
    }
    return null; // Renderiza nada si data está vacío
  }

  function IsDuracion(data) {
    if (data && data.trim && data.trim() !== "") {
      return (
        <p>
          <b>Duración:</b> {data}
        </p>
      );
    }
    return null; // Renderiza nada si data está vacío
  }

const programas = [
  {
    titulo: "Administración de Empresas",
    duracion: "4 años",
    facultad: "Ciencias Económicas y Empresariales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/empresas",
  },
  {
    titulo: "Agropecuaria",
    duracion: "4 años y medio",
    facultad: "Ciencias Exactas y Naturales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/agropecuaria",
  },
  {
    titulo: "Alimentos",
    duracion: "4 años y medio",
    facultad: "Ciencias Exactas y Naturales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/alimentos",
  },
  {
    titulo: "Arquitectura",
    duracion: "4 años y medio",
    facultad: "Ingenierías y Arquitectura",
    prueba: "Selección",
    url: "https://www.utpl.edu.ec/carreras/arquitectura",
  },
  {
    titulo: "Artes Escénicas",
    duracion: "4 años",
    facultad: "Ciencias Sociales, Educación y Humanidades",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/artesescenicas",
  },
  {
    titulo: "Artes Visuales",
    duracion: "4 años",
    facultad: "Ciencias Sociales, Educación y Humanidades",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/artes",
  },
  {
    titulo: "Bioquímica y Farmacia",
    duracion: "4 años y medio",
    facultad: "Ciencias Exactas y Naturales",
    prueba: "Selección",
    url: "https://www.utpl.edu.ec/carreras/bioquimica",
  },
  {
    titulo: "Biología",
    duracion: "4 años y medio",
    facultad: "Ciencias Exactas y Naturales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/biologia",
  },
  {
    titulo: "Computación",
    duracion: "4 años y medio",
    facultad: "Ingenierías y Arquitectura",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/computacion",
  },
  {
    titulo: "Contabilidad y Auditoría",
    duracion: "4 años",
    facultad: "Ciencias Económicas y Empresariales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/contabilidad",
  },
  {
    titulo: "Derecho",
    duracion: "4 años",
    facultad: "Ciencias Jurídicas y Políticas",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/derecho",
  },
  {
    titulo: "Economía",
    duracion: "4 años",
    facultad: "Ciencias Económicas y Empresariales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/economia",
  },
  {
    titulo: "Enfermería",
    duracion: "4 años y medio",
    facultad: "Ciencias de la Salud",
    prueba: "Selección",
    url: "https://www.utpl.edu.ec/carreras/enfermeria",
  },
  {
    titulo: "Finanzas",
    duracion: "4 años",
    facultad: "Ciencias Económicas y Empresariales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/finanzas",
  },
  {
    titulo: "Fisioterapia",
    duracion: "4 años y medio",
    facultad: "Ciencias de la Salud",
    prueba: "Selección",
    url: "https://www.utpl.edu.ec/carreras/fisioterapia",
  },
  {
    titulo: "Gastronomía",
    duracion: "4 años",
    facultad: "Ciencias Económicas y Empresariales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/gastronomia",
  },
  {
    titulo: "Geología",
    duracion: "4 años y medio",
    facultad: "Ingenierías y Arquitectura",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/geologia",
  },
  {
    titulo: "Ingeniería Ambiental",
    duracion: "4 años y medio",
    facultad: "Ciencias Exactas y Naturales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/ingenieriaambiental",
  },
  {
    titulo: "Ingeniería Civil",
    duracion: "4 años y medio",
    facultad: "Ingenierías y Arquitectura",
    prueba: "Selección",
    url: "https://www.utpl.edu.ec/carreras/civil",
  },
  {
    titulo: "Ingeniería Industrial",
    duracion: "4 años y medio",
    facultad: "Ciencias Exactas y Naturales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/industrial",
  },
  {
    titulo: "Ingeniería Química",
    duracion: "4 años y medio",
    facultad: "Ciencias Exactas y Naturales",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/quimica",
  },
  {
    titulo: "Medicina",
    duracion: "6 años",
    facultad: "Ciencias de la Salud",
    prueba: "Selección",
    url: "https://www.utpl.edu.ec/carreras/medicina",
  },
  {
    titulo: "Nutrición y Dietética",
    duracion: "4 años y medio",
    facultad: "Ciencias de la Salud",
    prueba: "Selección",
    url: "https://www.utpl.edu.ec/carreras/nutricion",
  },
  {
    titulo: "Pedagogía de los Idiomas Nacionales y Extranjeros",
    duracion: "4 años",
    facultad: "Ciencias Sociales, Educación y Humanidades",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/idiomas",
  },
  {
    titulo: "Psicología",
    duracion: "4 años",
    facultad: "Ciencias Sociales, Educación y Humanidades",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/psicologia",
  },
  {
    titulo: "Psicología Clínica",
    duracion: "4 años",
    facultad: "Ciencias Sociales, Educación y Humanidades",
    prueba: "Selección",
    url: "https://www.utpl.edu.ec/carreras/clinica",
  },
  {
    titulo: "Psicopedagogía",
    duracion: "4 años",
    facultad: "Ciencias Sociales, Educación y Humanidades",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/psicopedagogia",
  },
  {
    titulo: "Telecomunicaciones",
    duracion: "4 años y medio",
    facultad: "Ingenierías y Arquitectura",
    prueba: "Diagnóstica",
    url: "https://www.utpl.edu.ec/carreras/telecomunicaciones",
  },
];

  const handleChangePrueba = (selected) => {
    setPrueba(selected);
  };
  const handleChangeFacultad = (selected) => {
    setFacultad(selected);
  };

  const programasFiltrados = programas.filter((p) => {
    const coincidePrueba =
      !prueba ||
      prueba.value === "todos" ||
      p.prueba.toLowerCase() === prueba.value.toLowerCase();

    const coincideFacultad =
      !facultad ||
      facultad.value === "todos" ||
      p.facultad.toLowerCase() === facultad.value.toLowerCase();

    return coincidePrueba && coincideFacultad;
  });

  return (
    <div>
      <div className="bloque1 flex-center new-offer">
        <div>
          <p>
            <b>Tipo de prueba</b>
          </p>
          <Select
            options={optionsPrueba}
            defaultValue={optionsPrueba[0]}
            onChange={handleChangePrueba}
          />
        </div>
        <div>
          <p>
            <b>Facultad</b>
          </p>
          <Select
            options={optionsFacultad}
            defaultValue={optionsFacultad[0]}
            onChange={handleChangeFacultad}
          />
        </div>
      </div>

      <div className="bloque2 margin">
        <div className="wrapper-academicoffer">
          {programasFiltrados.map((programa, index) => (
            <div key={index}>
              <div className="layout8">
                {programa.tag && <p className="tag-cupos">{programa.tag}</p>}
                <h3>{programa.titulo}</h3>
                {IsDuracion(programa.duracion)}
                {programa.facultad && (
                  <p>
                    <b>Facultad: </b>
                    {programa.facultad}
                  </p>
                )}
                {programa.prueba && (
                  <p>
                    <b>Prueba de admisión: </b>
                    {programa.prueba}
                  </p>
                )}
                <div className="wrapper-link">
                  <a
                    className="link-offer"
                    href={programa.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver programa
                    <span className="material-icons">arrow_forward_ios</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
          {programasFiltrados.length === 0 && (
            <p>No hay programas disponibles.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default OfferPresencial;
